<template>
  <f7-page name="lms-taf" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>TAF</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-toolbar tabbar bottom>
        <f7-link tab-link="#taf-31" tab-link-active>TAF 24hod.</f7-link>
        <f7-link tab-link="#taf-41">TAF 9hod.</f7-link>
      </f7-toolbar>

      <f7-tabs>
        <f7-tab id="taf-31" tab-active>

          <div class="no-padding">
            <f7-list class="no-margin">
              <f7-list-item title="Vyberte čas:" smart-select :smart-select-params="{openIn: 'popover', searchbar: false, popupCloseLinkText:'Zavrieť', closeOnSelect:true}">
                <select v-model="selectedDate31">
                  <option v-for="date in listOfDates31" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }} UTC</option>
                </select>
              </f7-list-item>
            </f7-list>
          </div>

          <f7-block class="no-padding no-margin-vertical margin-horizontal-half">
            <strong>Predpoveď TAF s platnosťou 24 hod.</strong>

          <div class="padding-horizontal-half pre-ov-wpr">
            <template v-if="selectedContent31">
              <div class="pre-wrapper">
                <pre v-for="(content, index) in selectedContent31" :key="index" v-html="removeHeaderFromContnet(content.body, content.header)"></pre>
              </div>
            </template>

          </div>

          </f7-block>



        </f7-tab>
        <f7-tab id="taf-41">

          <div class="no-padding">
            <f7-list class="no-margin">
              <f7-list-item title="Vyberte čas:" smart-select :smart-select-params="{openIn: 'popover', searchbar: false, popupCloseLinkText:'Zavrieť', closeOnSelect:true}">
                <select v-model="selectedDate41">
                  <option v-for="date in listOfDates41" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }} UTC</option>
                </select>
              </f7-list-item>
            </f7-list>
          </div>

          <f7-block class="no-padding no-margin-vertical margin-horizontal-half">
            <strong>Predpoveď TAF s platnosťou 9 hod. </strong>

            <div class="padding-horizontal-half pre-ov-wpr">
              <template v-if="selectedContent41">
                <div class="pre-wrapper">
                  <pre v-for="(content, index) in selectedContent41" :key="index" v-html="removeHeaderFromContnet(content.body, content.header)"></pre>
                </div>
              </template>

            </div>

          </f7-block>

        </f7-tab>
      </f7-tabs>

    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      isDataLoaded: false,
      latestData31: [],
      listOfDates31: [],
      selectedDate31: null,

      latestData41: [],
      listOfDates41: [],
      selectedDate41: null,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },

  computed: {
    selectedDateIndex31() {
      const sDate = this.selectedDate31;
      return this.listOfDates31.findIndex(item => item === sDate);

    },
    selectedContent31() {
      const sDate = this.selectedDate31;
      if (sDate) {
        let r = this.latestData31.filter(item => item.dt === sDate);
        if (r.length) {
          r.sort((a, b) => (a.header > b.header) ? 1 : ((b.header > a.header) ? -1 : 0))
          return r;
        }
      }
    },
    selectedDateIndex41() {
      const sDate = this.selectedDate41;
      return this.listOfDates41.findIndex(item => item === sDate);

    },
    selectedContent41() {
      const sDate = this.selectedDate41;
      if (sDate) {
        let r = this.latestData41.filter(item => item.dt === sDate);
        if (r.length) {
          r.sort((a, b) => (a.header > b.header) ? 1 : ((b.header > a.header) ? -1 : 0))
          return r;
        }
      }
    },
  },

  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'lms/gettaf', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {

                let rData = response.data['data'];

                self.latestData31 = rData.filter(item => item.header.startsWith('FTSQ31'));
                self.latestData41 = rData.filter(item => item.header.startsWith('FCSQ41'));

                let allDates31 = [... new Set(self.latestData31.map((item) => item.dt))]; // unique
                self.listOfDates31 =  allDates31.sort().reverse();
                if (self.listOfDates31.length) {
                  self.selectedDate31 = self.listOfDates31[0];
                }

                let allDates41 = [... new Set(self.latestData41.map((item) => item.dt))]; // unique
                self.listOfDates41 =  allDates41.sort().reverse();
                if (self.listOfDates41.length) {
                  self.selectedDate41 = self.listOfDates41[0];
                }

                self.isDataLoaded = true;


                self.lastUpdated = self.$moment().unix();


              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať TAF správy', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    removeHeaderFromContnet(content, header) {
        return content;
    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    }

  }

};
</script>

<style lang="scss">

.pre-wrapper pre {
  font-size: 12px;
}

.pre-ov-wpr {
  overflow: auto;
  height: calc(100vh - var(--f7-navbar-height) - var(--f7-safe-area-top) - var(--f7-toolbar-height) - var(--f7-safe-area-bottom) - 100px);
}

</style>
